import {enableProdMode} from "@angular/core";
import {platformBrowser} from "@angular/platform-browser";
import {AppModule} from "./app/app.module";
import {environment} from "./environments/environment";
import {GlobalWorkerOptions} from "pdfjs-dist";

/*
 * Required by pdfjs-dist v5 (manual worker setup)
 */
GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

/*
 * Override console.* methods in order
 * So only ngxlogger can use the default console.* behaviour
 */

export const consoleLog = console.log;
export const consoleInfo = console.info;
export const consoleError = console.error;
export const consoleWarn = console.warn;
export const consoleDebug = console.debug;

if (environment.production) {
	enableProdMode();
}
platformBrowser().bootstrapModule(AppModule).then();
